// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"79003179","453":"926570ae","463":"603b9278","496":"665a298b","673":"8ea2bad0","683":"d9d750b6","800":"81a82798"}[chunkId] + ".chunk.js";
};